import { type CSSResult, unsafeCSS } from 'lit';

export type PaddingValue = string | number | CSSResult;

/**
 * Apply right padding.
 * @param {string | number} padding
 */
export function pr(padding: PaddingValue) {
	return unsafeCSS(`
		padding-inline-start: ${padding}
	`);
}

/**
 * Apply left padding.
 * @param {string | number} padding
 */
export function pl(padding: PaddingValue) {
	return unsafeCSS(`
		padding-inline-end: ${padding}
	`);
}

/**
 * Apply right/left paddings.
 * @param {string | number} padding
 */
export function px(padding: PaddingValue) {
	return unsafeCSS(`
		${pl(padding)};
		${pr(padding)}
	`);
}

/**
 * Apply top padding.
 * @param {string | number} padding
 */
export function pt(padding: PaddingValue) {
	return unsafeCSS(`
		padding-block-start: ${padding}
	`);
}

/**
 * Apply bottom padding.
 * @param {string | number} padding
 */
export function pb(padding: PaddingValue) {
	return unsafeCSS(`
		padding-block-end: ${padding}
	`);
}

/**
 * Apply top/bottom paddings.
 * @param {string | number} padding
 */
export function py(padding: PaddingValue) {
	return unsafeCSS(`
		${pt(padding)};
		${pb(padding)}
	`);
}

/**
 * Apply right/left/top/bottom paddings.
 * @param {string | number} padding
 */
function p(padding: PaddingValue) {
	return unsafeCSS(`
		${px(padding)};
		${py(padding)}
	`);
}

export default p;
